<template>
    <div class="box box-primary">
        <div class="box-header">
            <h3 class="box-title">Rechercher des opérations</h3>
        </div>
        <form method="POST" action="" @submit.prevent="refreshVueTable">
            <div class="box-body">
                <div class="row">
                    <div class="col-md-2">
                        <div class="form-group">
                            <label>Type d'opération:</label>
                            <div class="radio">
                                <label>
                                    <input type="radio" v-model="typeOperations" name="typeOperations"
                                           id="optionsRadios1" value="0" checked="">
                                    Toutes les opérations
                                </label>
                            </div>
                            <div class="radio">
                                <label>
                                    <input type="radio" v-model="typeOperations" name="typeOperations"
                                           id="optionsRadios2" value="1">
                                    Revenus uniquement
                                </label>
                            </div>
                            <div class="radio">
                                <label>
                                    <input type="radio" v-model="typeOperations" name="typeOperations"
                                           id="optionsRadios3" value="2">
                                    Dépenses uniquement
                                </label>
                            </div>
                        </div>

                        <div class="form-group">
                            <label>Ventilation:</label>
                            <div class="radio">
                                <label>
                                    <input type="radio" v-model="ventilationOperations" name="ventilationOperations"
                                           id="optionsVentilation1" value="0" checked="">
                                    Ventilée et non-ventilée
                                </label>
                            </div>
                            <div class="radio">
                                <label>
                                    <input type="radio" v-model="ventilationOperations" name="ventilationOperations"
                                           id="optionsVentilation2" value="1">
                                    Ventilée totalement
                                </label>
                            </div>
                            <div class="radio">
                                <label>
                                    <input type="radio" v-model="ventilationOperations" name="ventilationOperations"
                                           id="optionsVentilation4" value="2">
                                    Ventilée partiellement
                                </label>
                            </div>
                            <div class="radio">
                                <label>
                                    <input type="radio" v-model="ventilationOperations" name="ventilationOperations"
                                           id="optionsVentilation3" value="3">
                                    Non-ventilée et ventilée partiellement
                                </label>
                            </div>
                            <div class="radio">
                                <label>
                                    <input type="radio" v-model="ventilationOperations" name="ventilationOperations"
                                           id="optionsVentilation5" value="4">
                                    Non-ventilée uniquement
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-2 input-daterange" id="dataRange">
                        <div class="form-group">
                            <label>Du:</label>
                            <div class="input-group date ">
                                <div class="input-group-addon">
                                    <i class="fa fa-calendar"></i>
                                </div>
                                <input type="text" name="periodeDu" v-model="periodeDu"
                                       class="form-control pull-right datepicker" id="datepicker1">
                            </div>
                            <!-- /.input group -->
                        </div>
                        <div class="form-group ">
                            <label>Au:</label>
                            <div class="input-group date ">
                                <div class="input-group-addon">
                                    <i class="fa fa-calendar"></i>
                                </div>
                                <input type="text" name="periodeAu" v-model="periodeAu"
                                       class="form-control pull-right datepicker" id="datepicker2">
                            </div>
                            <!-- /.input group -->
                        </div>
                    </div>

                    <div class="col-md-6 col-md-push-1">
                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label for="montantOptions">
                                        Montant
                                    </label>
                                    <select name="montantOptions" id="montantOptions" class="pull-right form-control"
                                            v-model="montantOptions">
                                        <option value="0"></option>
                                        <option value="1">Egal à</option>
                                        <option value="2">Plus petit que</option>
                                        <option value="3">Plus grand que</option>
                                        <option value="4">Entre</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group" v-show="montantOptions != 0 && montantOptions!=null"
                                     :class="{ 'has-error': showErrorMontantDe }">
                                    <label for="MontantDe">&nbsp;</label>
                                    <div class="input-group">
                                        <span class="input-group-addon">€</span>
                                        <input type="text" name="montant" class="form-control" id="MontantDe"
                                               v-model="montant" placeholder="">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group" v-show="montantOptions == 4  && montantOptions!=null "
                                     :class="{ 'has-error': showErrorMontantEt }">
                                    <label for="MontantEt">&nbsp;</label>
                                    <div style="float:left">Et</div>
                                    <div class="input-group">
                                        <span class="input-group-addon">€</span>
                                        <input type="text" name="montant_limite" id="MontantEt" v-model="montantLimite"
                                               class="form-control" placeholder="">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <hr>
                            <div class="col-md-7">
                                <div class="form-group">
                                    <label for="inputCommunication">Communication</label>
                                    <input type="text" v-model="communication" class="form-control" name="communication"
                                           id="inputCommunication" placeholder="Partie de la communication">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <!--<div class="form-group">-->
                                <!--<label>Rubrique</label>-->
                                <!--<select name="rubrique" class="form-control">-->
                                <!--<option selected="selected">Toutes</option>-->
                                <!--<option>option 2</option>-->
                                <!--<option>option 3</option>-->
                                <!--<option>option 4</option>-->
                                <!--<option>option 5</option>-->
                                <!--</select>-->
                                <!--</div>-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="box-footer">
                <input type="submit" value="Rechercher" class="btn btn-primary pull-right"/>
            </div>
        </form>
    </div>
</template>


<script type="text/babel">
    import {mapGetters, mapActions} from 'vuex'
    //    import date from './components/Communs/UploadFile.vue'

    // var $ = require('jquery')
    // require('../../../node_modules')
    require('../../../node_modules/bootstrap-datepicker/js/bootstrap-datepicker')
    require('../../../node_modules/bootstrap-datepicker/js/locales/bootstrap-datepicker.fr')
    // require('../../../../../public/plugins/datepicker/bootstrap-datepicker');
    // require('../../../../../public/plugins/datepicker/locales/bootstrap-datepicker.fr.js');

    export default {
        data() {
            return {
                montantOptionsSelected: 0,
//                searchRequest: [],
                typeOperations: null,
                ventilationOperations: null,
                montant: null,
                montantLimite: null,
                montantOptions: null,
                periodeDu: null,
                periodeAu: null,
                communication: null,
                showErrorMontantEt: false,
                showErrorMontantDe: false
            }
        },
        computed: {
            ...mapGetters({
                searchRequest: 'getSearchRequest',
                getRoute: 'getRoute'
            })
        },
        mounted: function () {
            var these = this
            this.$nextTick(function () {
                $('.input-daterange').datepicker({
                    autoclose: true,
                    language: 'fr',
                }).on("changeDate", function (e) {
                    these.periodeDu = $('#datepicker1').val()
                    these.periodeAu = $('#datepicker2').val()
                });
            })
        },
        methods: {
            ...mapActions({
                submitToProcess: 'submitToProcess',
                majSearchRequest: 'majSearchRequest',
            }),
            constructSearchRequest: function () {
                var objectTemp = {}
                if (this.typeOperations != '' && this.typeOperations != null)
                    objectTemp.typeOperations = this.typeOperations
                if (this.ventilationOperations != '' && this.ventilationOperations != null)
                    objectTemp.ventilationOperations = this.ventilationOperations
                if (this.montant != '' && this.montant != null)
                    objectTemp.montant = this.montant
                if (this.montantOptions != '' && this.montantOptions != null)
                    objectTemp.montantOptions = this.montantOptions
                if (this.montantLimite != '' && this.montantLimite != null)
                    objectTemp.montant_limite = this.montantLimite
                if (this.periodeDu != '' && this.periodeDu != null)
                    objectTemp.periodeDu = this.periodeDu
                if (this.periodeAu != '' && this.periodeAu != null)
                    objectTemp.periodeAu = this.periodeAu
                if (this.communication != '' && this.communication != null)
                    objectTemp.communication = this.communication
                this.majSearchRequest(objectTemp);
            },
            refreshVueTable: function () {
                this.showErrorMontantDe = false;
                this.showErrorMontantEt = false;

                if (this.montantOptions >= 1 && this.montant == null)
                    this.showErrorMontantDe = true
                else if (this.montantOptions == 4 && this.montantLimite == null)
                    this.showErrorMontantEt = true
                else
                    this.submitToProcess(true)
            }
        },
        watch: {
            'typeOperations': function (val) {
                this.constructSearchRequest()
            },
            'ventilationOperations': function (val) {
                this.constructSearchRequest()
            },
            'montant': function (val) {
                this.constructSearchRequest()
            },
            'montantLimite': function (val) {
                this.constructSearchRequest()
            },
            'montantOptions': function (val) {
                if (val == 0) {
                    this.montant = null
                    this.montantLimite = null
                }
                this.constructSearchRequest()
            },
            'periodeDu': function (val) {
                this.constructSearchRequest()
            },
            'periodeAu': function (val) {
                this.constructSearchRequest()
            },
            'communication': function (val) {
                this.constructSearchRequest()
            },

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Recherches/RechercheOperation.vue